export default "__VITE_ASSET__PcU$CD3W__"